$(document).ready(function () {

  // Analytics events
  var analyticsEvents = [];
  FN.analytics.addConfiguredEvents(analyticsEvents);


  // Mobile navigation toggle
  $('#nav-toggle').on('click', function () {
    $('#tower-claim').toggle();
    var navDisplay = ($('#tower-claim').is(':visible')) ? 'none' : 'table-cell';
    $('nav ul').css('display', navDisplay);
  });
});



